// This list comes from this thread from Slack: https://coursera.slack.com/archives/C07FMU3CC0G/p1736366076994799

export const RANKED_ROLES_LIST = [
  'data-scientist',
  'data-analyst',
  'machine-learning-engineer',
  'it-project-manager',
  'technology-consultant',
  'business-management-analyst',
  'business-intelligence-analyst',
  'data-warehouse-developer',
  'product-manager',
  'marketing-analytics-specialist',
  'business-analyst-general',
  'statistician',
  'project-manager',
  'video-game-developer',
  'data-architect',
  'cyber-security-engineer',
  'logistics-supply-chain-analyst',
  'mainframe-developer',
  'automation-engineer',
  'user-interface-user-experience-ui-ux-manager',
  'cyber-information-security-engineer-analyst',
  'back-end-developer-engineer',
  'data-engineer',
  'technical-support-engineer-analyst',
  'social-media-strategist-specialist',
  'real-estate-agent',
  'tax-analyst-specialist',
  'human-resources-specialist',
  'bookkeeper-accounting-clerk',
  'sales-representative',
  'full-stack-developer',
  'ios-developer-engineer',
  'scrum-master',
  'cloud-architect',
  'sales-development-representative',
  'digital-marketing-specialist',
  'cyber-security-specialist-technician',
  'solutions-application-architect',
  'sales-operations-specialist',
  'front-end-developer',
  'devops-engineer',
  'customer-service-representative',
  'application-developer-engineer',
  'android-developer-engineer',
  'network-systems-administrator',
  'career-counselor',
  'network-engineer-architect',
  'computer-support-specialist',
  'analytics-manager',
  'actuary',
  'risk-consultant',
  'market-research-analyst',
  'computer-scientist',
  'business-intelligence-architect-developer',
  'data-warehousing-specialist',
  'strategic-planner-analyst',
  'business-management-consultant',
  'risk-analyst',
  'diversity-equity-and-inclusion-specialist',
  'chief-information-officer',
  'risk-manager-analyst',
  'chief-data-officer',
  'aerospace-engineer',
  'researcher-research-associate',
  'fraud-examiner-analyst',
  'business-program-analyst',
  'data-data-mining-analyst',
  'corporate-development-analyst',
  'advertising-promotions-manager',
  'program-manager',
  'marketing-analyst',
  'pricing-analyst',
  'supply-chain-analyst',
  'talent-acquisition-recruiting-manager',
  'sustainability-specialist',
  'human-resources-analyst',
  'data-manager',
  'market-research-analyst-general',
  'risk-manager',
  'financial-quantitative-analyst',
  'biologist',
  'business-development-manager',
  'business-analysis-manager',
  'project-management-analyst',
  'human-resources-consultant',
  'product-manager-general',
  'e-commerce-analyst',
  'writer',
  'director-of-project-management',
  'compensation-benefits-analyst',
  'budget-analyst',
  'systems-engineer',
  'energy-engineer',
  'employee-relations-specialist',
  'logistics-analyst',
  'chemical-process-engineer',
  'product-development-manager',
  'systems-integration-engineer-specialist',
  'inventory-control-manager',
  'compensation-benefits-manager',
];

// This list comes from this thread: https://coursera.slack.com/archives/C08NLEKPA11/p1754678155713259?thread_ts=1754672195.078659&cid=C08NLEKPA11
// It is a newly revised list that has been updated to include more roles.
export const EXTENDED_RANKED_ROLES_LIST = [
  'data-scientist',
  'data-analyst',
  'marketing-analytics-specialist',
  'machine-learning-engineer',
  'data-warehouse-developer',
  'technology-consultant',
  'business-management-analyst',
  'product-manager',
  'business-intelligence-analyst',
  'data-manager',
  'compensation-benefits-analyst',
  'program-manager',
  'digital-marketing-specialist',
  'business-analyst-general',
  'logistics-supply-chain-analyst',
  'python-developer',
  'statistician',
  'data-architect',
  'project-manager',
  'video-game-developer',
  'cyber-security-engineer',
  'it-project-manager',
  'solutions-application-architect',
  'human-resources-specialist',
  'communications-public-relations-specialist',
  'automation-engineer',
  'software-developer-engineer',
  'back-end-developer-engineer',
  'data-engineer',
  'mainframe-developer',
  'network-systems-administrator',
  'cyber-information-security-engineer-analyst',
  'user-interface-user-experience-ui-ux-manager',
  'social-media-strategist-specialist',
  'technical-support-engineer-analyst',
  'video-game-designer',
  'tax-analyst-specialist',
  'content-creator',
  'front-end-developer',
  'bookkeeper-accounting-clerk',
  'real-estate-agent',
  'network-engineer-architect',
  'scrum-master',
  'sales-representative',
  'application-developer-engineer',
  'cloud-architect',
  'cyber-security-specialist-technician',
  'sales-development-representative',
  'graphic-designer-desktop-publisher',
  'full-stack-developer',
  'sales-operations-specialist',
  'customer-service-representative',
  'payroll-specialist',
  'android-developer-engineer',
  'ios-developer-engineer',
  'computer-support-specialist',
  'devops-engineer',
  'career-counselor',
  'medical-office-practice-manager',
  'personal-trainer-fitness-instructor',
  'analytics-manager',
  'actuary',
  'risk-consultant',
  'computer-scientist',
  'business-intelligence-architect-developer',
  'healthcare-analyst',
  'data-warehousing-specialist',
  'market-research-analyst',
  'research-scientist',
  'strategic-planner-analyst',
  'risk-analyst',
  'researcher-research-associate',
  'business-management-consultant',
  'chief-information-officer',
  'aerospace-engineer',
  'diversity-equity-and-inclusion-specialist',
  'data-data-mining-analyst',
  'research-analyst',
  'chief-data-officer',
  'clinical-analyst-clinical-documentation-improvement-specialist',
  'fraud-examiner-analyst',
  'risk-manager-analyst',
  'business-program-analyst',
  'corporate-development-analyst',
  'marketing-analyst',
  'biologist',
  'advertising-promotions-manager',
  'database-administrator',
  'supply-chain-analyst',
  'pricing-analyst',
  'compliance-manager',
  'sustainability-specialist',
  'financial-quantitative-analyst',
  'operations-analyst',
  'market-research-analyst-general',
  'energy-engineer',
  'talent-acquisition-recruiting-manager',
  'human-resources-analyst',
  'risk-manager',
  'systems-engineer',
  'project-management-analyst',
  'database-architect',
  'biomedical-scientist',
  'business-analysis-manager',
  'product-manager-general',
  'systems-integration-engineer-specialist',
  'financial-analyst',
  'systems-architect',
  'director-of-project-management',
  'business-development-manager',
  'human-resources-consultant',
  'budget-analyst',
  'logistics-analyst',
  'marketing-analytics-manager',
  'marketing-manager',
  'chemical-process-engineer',
  'product-development-manager',
  'inventory-control-manager',
  'employee-relations-specialist',
  'chemist',
  'writer',
  'systems-analyst',
  'supply-chain-manager',
  'biostatistician',
  'e-commerce-analyst',
  'compensation-benefits-manager',
  'data-specialist',
  'clinical-data-analyst',
  'mechanical-engineer',
  'revenue-manager',
  'equal-opportunity-representative-officer',
  'human-resources-manager',
  'software-qa-lead',
  'marketing-assistant-associate',
  'environmental-engineer',
  'compliance-officer-analyst',
  'brand-manager',
  'marketing-specialist-general',
  'program-coordinator',
  'contract-administrator',
  'program-manager-general',
  'general-manager',
  'procurement-analyst',
  'research-assistant',
  'elementary-secondary-school-administrator',
  'chief-operating-officer',
  'chief-executive-officer',
  'financial-manager-general',
  'public-relations-director',
  'financial-analyst-general',
  'reliability-engineer',
  'it-director',
  'validation-engineer',
  'electronics-engineer',
  'demand-planning-analyst',
  'software-architect',
  'full-stack-cloud-developer',
  'financial-services-manager',
  'research-technician',
  'c-cplusplus-developer-engineer',
  'content-marketing-specialist',
  'clinical-data-specialist-manager',
  'communications-manager',
  'chief-human-resources-officer',
  'payroll-manager',
  'it-manager-director',
  'brand-marketing-specialist',
  'contracts-analyst',
  'public-relations-manager',
  'health-information-director',
  'digital-marketing-manager',
  'big-data-architect',
  'staffing-manager',
  'vice-president-of-marketing',
  'health-information-manager',
  'physicist',
  'water-resource-specialist',
  'logistician-supply-chain-specialist',
  'financial-planner-investment-consultant',
  'securities-commodities-trader',
  'supply-chain-specialist',
  'chief-of-staff',
  'claims-specialist-adjuster-examiner',
  'chief-financial-officer',
  'search-engine-optimization-specialist',
  'cloud-security-engineer',
  'project-manager-general',
  'vice-president-of-human-resources',
  'customer-service-director',
  'user-experience-ux-researcher',
  'marketing-specialist',
  'communications-director',
  'banking-branch-manager',
  'training-development-specialist',
  'purchasing-agent',
  'estimator',
  'logistics-director',
  'supply-chain-logistics-manager',
  'corporate-development-manager',
  'procurement-sourcing-specialist',
  'biomedical-engineer',
  'media-talent-director',
  'content-marketing-manager',
  'account-representative',
  'training-development-manager',
  'it-specialist-engineer',
  'contracts-manager',
  'grants-manager-administrator',
  'transportation-manager',
  'editor',
  'buyer-general',
  'technical-support-manager-supervisor',
  'environmental-compliance-specialist',
  'insurance-underwriter',
  'account-manager-representative',
  'procurement-sourcing-manager',
  'solutions-engineer',
  'public-administrator',
  'auditor',
  'food-agricultural-scientist-technologist',
  'buyer-purchasing-agent',
  'regulatory-affairs-manager',
  'chief-sales-officer',
  'cyber-security-manager-administrator',
  'regulatory-affairs-specialist',
  'assistant-project-manager',
  'recruiting-manager',
  'software-development-engineering-manager',
  'industrial-engineer',
  'it-auditor',
  'creative-director',
  'operations-maintenance-specialist',
  'it-operations-networking-manager',
  'real-estate-agent-broker',
  'safety-manager',
  'technical-program-manager',
  'treasury-analyst',
  'financial-manager',
  'healthcare-account-manager',
  'financial-consultant',
  'safety-manager-general',
  'operations-manager',
  'environmental-health-safety-ehs-director',
  'diversity-equity-and-inclusion-manager-director',
  'director-of-sales',
  'healthcare-project-manager',
  'videographer',
  'environmental-health-safety-ehs-manager',
  'customer-service-manager',
  'account-manager',
  'quality-control-analyst',
  'corporate-development-analyst-manager',
  'technical-writer',
  'medical-research-scientist',
  'product-owner',
  'copywriter',
  'healthcare-administrator',
  'logistics-manager',
  'tax-manager',
  'customer-experience-manager',
];

export default {
  RANKED_ROLES_LIST,
  EXTENDED_RANKED_ROLES_LIST,
};
